import React, { useState, useEffect, useContext } from 'react'
import { BiLoaderAlt } from 'react-icons/bi'
import { useNavigate } from 'react-router'
import { toast } from 'react-toastify'
import { BASE_URL_API } from '../../References/URLs'
import ActiveStoreContext from '../../store/ActiveStoreContext'
import AuthContext from '../../store/auth-context'
import styles from './MembershipLanding.module.css'

const MembershipLanding = () => {
    const authCtx = useContext(AuthContext)
    const asCtx = useContext(ActiveStoreContext)
    const activeStore = (() => { try { return asCtx?.activeStore && asCtx.activeStore.trim() !== "" ? JSON.parse(asCtx.activeStore) : null; } catch { return null; } })();
    const vendorIdentifier = JSON.parse(authCtx?.loginData)?.partnersData?.vendorIdentifier
    const [isCreating, setIsCreating] = useState(false)
    const nav = useNavigate()

    const [isLoaded, setIsLoaded] = useState(false)
    const [mousePos, setMousePos] = useState({ x: 0, y: 0 })

    useEffect(() => {
        setIsLoaded(true)

        const handleMouseMove = (e) => {
            setMousePos({
                x: e.clientX / window.innerWidth,
                y: e.clientY / window.innerHeight
            })
        }

        window.addEventListener('mousemove', handleMouseMove)
        return () => window.removeEventListener('mousemove', handleMouseMove)
    }, [])

    const createFirstMembership = () => {
        console.log('Creating first membership...')
    }

    const showDemo = () => {
        console.log('Showing demo...')
    }

    const showFeature = (feature) => {
        console.log(`Exploring ${feature} feature...`)
    }

    // const createSuperAdmin = async () => {
    //     const response = await fetch(BASE_URL_API+"createSuperAdmin",
    //     {
    //         method : "POST",
    //         body : JSON.stringify({
    //             token : authCtx.token,
    //             vendorIdentifier : '1747298734rbOaT6Ndn7kK',
    //             username : 'salon1995',
    //             displayName : '1995 Unisex Salon'
    //         })
    //     });

    //     if(!response.ok) {
    //         console.log("Something went wrong : server error")
    //     } else {
    //         const respo = await response.json()
    //         if(respo.status==="success") {

    //         } else {
    //             if(respo.message==="tokenExpired") {
    //                 authCtx.logout()
    //             }
    //         }
    //         console.log(respo)
    //     }

    // }

    const enableMembership = async () => {
        setIsCreating(true)
        const response = await fetch(BASE_URL_API + "enableMembership",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    vendorIdentifier: vendorIdentifier,
                    storeIdentifier : activeStore?.storeIdentifier
                })
            });

        if (!response.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const respo = await response.json()
            if (respo?.status === "success") {
                toast(`Successfully enabled the membership plan!`)
                nav(`/memberships/settings`)
            } else {
                if (respo?.message === "tokenExpired") {
                    authCtx.logout()
                }
            }
        }
        setIsCreating(false)

    }


    return (
        <div className={styles.mainWrapper}>
            {/* Animated background particles */}
            <div className={styles.bgParticles}>
                {[...Array(9)].map((_, i) => (
                    <div
                        key={i}
                        className={styles.particle}
                        style={{
                            left: `${(i + 1) * 10}%`,
                            animationDelay: `${i * 0.5}s`,
                            transform: `translate(${mousePos.x * (i + 1) * 0.5}px, ${mousePos.y * (i + 1) * 0.5}px)`
                        }}
                    />
                ))}
            </div>

            {/* Header */}
            {/* <header className={styles.header}>
                <div className={styles.logo}>
                    <div className={styles.logoIcon}>⚡</div>
                    <span>MembershipPro</span>
                </div>
                <div className={styles.userMenu}>
                    <div className={styles.userAvatar}>JD</div>
                </div>
            </header> */}

            {/* Main Content */}
            <main className={`${styles.mainContent} ${isLoaded ? styles.loaded : ''}`}>
                <div className={styles.heroIcon}>
                    🚀
                </div>

                <h1 className={styles.heroTitle}>Welcome to the Future</h1>
                <h2 className={styles.heroSubtitle}>of Membership Management</h2>
                <p className={styles.heroDescription}>
                    Transform how you manage memberships with our revolutionary platform.
                    Built with cutting-edge AI and designed for scale, this is membership management
                    like you've never experienced before.
                </p>

                <div className={styles.ctaButtons}>
                    {isCreating === true ?
                        <button className={`${styles.btn} ${styles.btnPrimary}`}>
                            <BiLoaderAlt size={18} className={styles.spinner} /> Creating now, Please wait...
                        </button>
                        :
                        <button className={`${styles.btn} ${styles.btnPrimary}`} onClick={() => enableMembership()}>
                            ✨ Create Your First Membership
                        </button>
                    }
                    <button className={`${styles.btn} ${styles.btnSecondary}`} onClick={showDemo}>
                        🎯 See How It Works
                    </button>
                </div>

                <div className={styles.featurePreview}>
                    <div className={styles.featureCard} onClick={() => showFeature('analytics')}>
                        <div className={styles.featureIcon}>📊</div>
                        <h3 className={styles.featureTitle}>Smart Analytics</h3>
                        <p className={styles.featureDescription}>
                            AI-powered insights that predict member behavior and optimize retention automatically.
                        </p>
                    </div>

                    <div className={styles.featureCard} onClick={() => showFeature('automation')}>
                        <div className={styles.featureIcon}>🤖</div>
                        <h3 className={styles.featureTitle}>Intelligent Automation</h3>
                        <p className={styles.featureDescription}>
                            Workflows that adapt and learn, handling everything from onboarding to renewals seamlessly.
                        </p>
                    </div>

                    <div className={styles.featureCard} onClick={() => showFeature('engagement')}>
                        <div className={styles.featureIcon}>💎</div>
                        <h3 className={styles.featureTitle}>Hyper Engagement</h3>
                        <p className={styles.featureDescription}>
                            Personalized member experiences that increase satisfaction and lifetime value by 300%.
                        </p>
                    </div>
                </div>
            </main>
        </div>
    )
}

export default MembershipLanding